import { isJsonObject } from "../errors.js";
export const ONBOARDING_STATUS_QUERY = "onboarding.status.v1";
export const ONBOARDING_COMMAND = "onboarding.command.v1";
export const ONBOARDING_EVENTS = "onboarding.events.v1";
export function isOnboardingCommand(value) {
    if (!isJsonObject(value) || typeof value.kind !== "string")
        return false;
    switch (value.kind) {
        case "redeem-invitation":
            return typeof value.code === "string";
        case "advance-discovery":
        case "skip-invitation":
        case "confirm-matchcode":
        case "retry-approval":
        case "reconcile-completion":
        case "cancel":
            return true;
        case "submit-identity":
            return typeof value.username === "string"
                && typeof value.displayName === "string"
                && typeof value.nodeName === "string";
        case "submit-wifi":
            return typeof value.ssid === "string" && typeof value.secret === "string";
        case "choose-path":
            return isOnboardingScenario(value.scenario);
        default:
            return false;
    }
}
function isOnboardingScenario(value) {
    return value === "new"
        || value === "pair"
        || value === "wifi"
        || value === "expired"
        || value === "lost";
}
//# sourceMappingURL=onboarding-contract.js.map